import { render, staticRenderFns } from "./upLoadVideoDialog.vue?vue&type=template&id=5f8217c4&scoped=true"
import script from "./upLoadVideoDialog.vue?vue&type=script&lang=js"
export * from "./upLoadVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./upLoadVideoDialog.vue?vue&type=style&index=0&id=5f8217c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8217c4",
  null
  
)

export default component.exports